export const PAGE_SIZE_OPTIONS: ReadonlyArray<number> = [10, 25, 50, 100];

const PAGE_SIZE_STORAGE_KEY = 'enrollio.portal.pageSize';

export function pageSizeOptions(current: number): ReadonlyArray<number> {
  return PAGE_SIZE_OPTIONS.includes(current)
    ? PAGE_SIZE_OPTIONS
    : [...PAGE_SIZE_OPTIONS, current].sort((a, b) => a - b);
}

export function getStoredPageSize(fallback = 10): number {
  try {
    const stored = window.localStorage.getItem(PAGE_SIZE_STORAGE_KEY);
    const parsed = stored === null ? Number.NaN : Number.parseInt(stored, 10);
    return PAGE_SIZE_OPTIONS.includes(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
}

export function setStoredPageSize(pageSize: number): void {
  try {
    window.localStorage.setItem(PAGE_SIZE_STORAGE_KEY, String(pageSize));
  } catch {
    // Storage unavailable (e.g. private mode) — preference just won't persist.
  }
}
